import _ from 'lodash';
import { computed } from 'vue';

import { useStore } from 'vuex';

export default function useAuth() {
  const store = useStore();
  const meRef = computed(() => _.get(store, 'state.Auth.me'));
  return { meRef };
}
